<!-- banner  -->
<div class="collab-banner sticky-header-banner banner-sec">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative pb-0">
            <div class="text-center z-index pb-2">

                <div class="mx-auto whats-new-label transparent-bg">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div> 
                    <span class="paragraph-global-text sub-head-paragraph">
                        {{'realEstate.banner.preTitle' | translate}}
                    </span>
                </div>

                <h1 class="banner-heading mx-auto mw-700">{{'realEstate.banner.title' | translate}}</h1>
                <p class="paragraph-global-text mw-650">{{'realEstate.banner.description' | translate}}</p>
                <div class="mt-5 mb-5 mx-auto button-container align-items-start">
                    <form [formGroup]="emailValidations" (ngSubmit)="onSubmit()" class="input-form btn p-0">
                        <input type="text" id="workmail" (input)="domainError = false" class="form-control banner-input border-purple-700" placeholder="Enter your work email" formControlName="emailId" required>            
                        <!-- <div class="error-message text-left title-color pl-3" *ngIf="emailValidations.get('emailId').touched && emailValidations.get('emailId').dirty && emailValidations.get('emailId').hasError('required')">
                            Email is required.
                          </div>
                          <div class="error-message text-left title-color pl-3" *ngIf="emailValidations.get('emailId').touched && emailValidations.get('emailId').dirty && (emailValidations.get('emailId').hasError('email') || (emailValidations.get('emailId').hasError('pattern')))">
                            Please enter a valid email.
                          </div>     
                          <div class="error-message text-left title-color pl-3" *ngIf="domainError">
                            Enter a valid workmail
                          </div>    -->
                    </form>
                    <a class="save-btn cfa btn" (click)="onSubmit()">
                        {{'realEstate.banner.btnText' | translate}}    
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<p-toast position="bottom-left"></p-toast>

<div class="sec-padding">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{"realEstate.designServices.title" | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800 mb-0">{{'realEstate.designServices.description' | translate}}</p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                     <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-building-2 icon-primary-color"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4"/><path d="M10 10h4"/><path d="M10 14h4"/><path d="M10 18h4"/></svg>
                     </div>
                     <h4 class="heading-three pt-1">{{'realEstate.designServices.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300">{{'realEstate.designServices.section1.description' | translate}}</p>
                     <ul class="disc-list">
                        <li class="paragraph-global-text">{{'realEstate.designServices.section1.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section1.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section1.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section1.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section1.point5' | translate}}</li>
                     </ul>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text icon-primary-color"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'realEstate.designServices.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300">{{'realEstate.designServices.section2.description' | translate}}</p>
                     <ul class="disc-list">
                        <li class="paragraph-global-text">{{'realEstate.designServices.section2.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section2.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section2.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section2.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section2.point5' | translate}}</li>
                     </ul>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-cuboid icon-primary-color"><path d="m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z"/><path d="M10 22v-8L2.25 9.15"/><path d="m10 14 11.77-6.87"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'realEstate.designServices.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300">{{'realEstate.designServices.section3.description' | translate}}</p>
                     <ul class="disc-list">
                        <li class="paragraph-global-text">{{'realEstate.designServices.section3.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section3.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section3.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section3.point4' | translate}}</li>
                     </ul>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                     <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-hotel icon-primary-color"><path d="M10 22v-6.57"/><path d="M12 11h.01"/><path d="M12 7h.01"/><path d="M14 15.43V22"/><path d="M15 16a5 5 0 0 0-6 0"/><path d="M16 11h.01"/><path d="M16 7h.01"/><path d="M8 11h.01"/><path d="M8 7h.01"/><rect x="4" y="2" width="16" height="20" rx="2"/></svg>
                     </div>
                     <h4 class="heading-three pt-1">{{'realEstate.designServices.section4.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300">{{'realEstate.designServices.section4.description' | translate}}</p>
                     <ul class="disc-list">
                        <li class="paragraph-global-text">{{'realEstate.designServices.section4.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section4.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section4.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section4.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section4.point5' | translate}}</li>
                     </ul>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pen-tool icon-primary-color"><path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z"/><path d="m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18"/><path d="m2.3 2.3 7.286 7.286"/><circle cx="11" cy="11" r="2"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'realEstate.designServices.section5.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300">{{'realEstate.designServices.section5.description' | translate}}</p>
                     <ul class="disc-list">
                        <li class="paragraph-global-text">{{'realEstate.designServices.section5.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section5.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section5.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section5.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section5.point5' | translate}}</li>
                     </ul>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-notepad-text icon-primary-color"><path d="M8 2v4"/><path d="M12 2v4"/><path d="M16 2v4"/><rect width="16" height="18" x="4" y="4" rx="2"/><path d="M8 10h6"/><path d="M8 14h8"/><path d="M8 18h5"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'realEstate.designServices.section6.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300">{{'realEstate.designServices.section6.description' | translate}}</p>
                     <ul class="disc-list">
                        <li class="paragraph-global-text">{{'realEstate.designServices.section6.point1' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section6.point2' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section6.point3' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section6.point4' | translate}}</li>
                        <li class="paragraph-global-text">{{'realEstate.designServices.section6.point5' | translate}}</li>
                     </ul>
                </div>
             </div>
        </div>
    </div>
</div>


<div class="sec-padding how-it-works-section sec-teritiary-background">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{"realEstate.howItWorks.title" | translate}}</h2>
        </div>

        <div class="grid-container">
            
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                  <h3>{{"realEstate.howItWorks.section1.title" | translate}}</h3>
                  <p>{{"realEstate.howItWorks.section1.description" | translate}}</p>
                </div>
              </div>
              <div class="arrow-top">
                <svg width="94px" height="94px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#5F54EE"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M56 270.5C56 256.429 79.5553 218.859 120.902 197.186C162.249 175.512 194.07 164.5 242.113 164.5C274.142 164.5 306.771 175.395 340 197.186" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="16 32"></path> <path d="M325.63 129C337.877 172.588 344 195.072 344 196.45C344 198.518 308.436 212.998 292 235" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>                             
              </div>
            </div>
          
            
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                    <h3>{{"realEstate.howItWorks.section2.title" | translate}}</h3>
                    <p>{{"realEstate.howItWorks.section2.description" | translate}}</p>
                </div>
              </div>
              <div class="arrow-bottom">
                <svg width="94px" height="94px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#5F54EE" transform="matrix(1, 0, 0, -1, 0, 0)rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M56 270.5C56 256.429 79.5553 218.859 120.902 197.186C162.249 175.512 194.07 164.5 242.113 164.5C274.142 164.5 306.771 175.395 340 197.186" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="16 32"></path> <path d="M325.63 129C337.877 172.588 344 195.072 344 196.45C344 198.518 308.436 212.998 292 235" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              </div>
            </div>
          
          
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                    <h3>{{"realEstate.howItWorks.section3.title" | translate}}</h3>
                    <p>{{"realEstate.howItWorks.section3.description" | translate}}</p>
                </div>
              </div>
              <div class="arrow-top">
                <svg width="94px" height="94px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#5F54EE"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M56 270.5C56 256.429 79.5553 218.859 120.902 197.186C162.249 175.512 194.07 164.5 242.113 164.5C274.142 164.5 306.771 175.395 340 197.186" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="16 32"></path> <path d="M325.63 129C337.877 172.588 344 195.072 344 196.45C344 198.518 308.436 212.998 292 235" stroke="#5F54EE" stroke-opacity="0.9" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              </div>
            </div>
          
            
            <div class="card">
              <div class="card-content">
                <div class="text-center">
                    <h3>{{"realEstate.howItWorks.section4.title" | translate}}</h3>
                    <p>{{"realEstate.howItWorks.section4.description" | translate}}</p>
                </div>
              </div>
            </div>
          </div>
    </div>
</div>

<div class="sec-padding">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{"realEstate.featuredProjects.title" | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800 mb-0">{{'realEstate.featuredProjects.description' | translate}}</p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card banner-img-card">
                     <div>
                        <img class="banner-card-image w-100" src="https://media.istockphoto.com/id/1497628484/photo/modern-office-interior-with-exposed-concrete-ceiling-and-floor-3d-rendering.webp?a=1&s=612x612&w=0&k=20&c=YCWNo6Ksv95y5E7aT2YkYV0dyCiszE9eMeRCTk4X_xE=" alt="">
                     </div>
                     <h4 class="heading-three mt-4">{{'realEstate.featuredProjects.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mb-0 mx-auto" style="max-width: 250px;">{{'realEstate.featuredProjects.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card banner-img-card">
                    <div>
                        <img class="banner-card-image w-100" src="https://media.istockphoto.com/id/524033994/photo/home-interior-3d-rendering.jpg?s=612x612&w=0&k=20&c=MvcuzqAt3a_EQTYVF8Znkh6RFUWbZXooF_u7oi0LFkw=" alt="">
                     </div>
                     <h4 class="heading-three mt-4">{{'realEstate.featuredProjects.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mb-0 mx-auto" style="max-width: 250px;">{{'realEstate.featuredProjects.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card banner-img-card">
                    <div>
                        <img class="banner-card-image w-100" src="https://media.istockphoto.com/id/522645617/photo/empty-glasses-in-restaurant.webp?a=1&b=1&s=612x612&w=0&k=20&c=4dA4JK7duSvYHy2Pva8-HINl3AZPNJ12r1pWbsMuyhQ=" alt="">
                     </div>
                     <h4 class="heading-three mt-4">{{'realEstate.featuredProjects.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mb-0 mx-auto" style="max-width: 250px;">{{'realEstate.featuredProjects.section3.description' | translate}}</p>
                </div>
             </div>
        </div>
    </div>
</div>


<!-- pricing  section-->
<div class="sec-padding pricing-section sec-teritiary-background" *ngIf="projectPlans && projectPlans?.length > 0">
    <div class="container position-relative">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto mw-800">{{"realEstate.pricing.title" | translate}} </h2>
            <p class="paragraph-global-text mw-900 sub-head-paragraph mx-auto pb-0">{{"realEstate.pricing.description" | translate}}</p>
        </div>
        <div class="row mx-0 pt-5 m-col-width">
            <!-- regular glance view  -->
            <div class="col-lg-4 col-md-6 col-sm-12 mb-4" *ngFor="let plan of projectPlans;let planIdx = index;">
                <div class="pricing-card-css-margin hide-on-mobile" *ngIf="planIdx !== 1"><span></span></div>
                <div class="card border pricing-card h-100 position-relative" [ngClass]="{'active-card' : planIdx == 1}">
                    <div class="card-body">
                        <div class="card-top-part">
                            <h4 class="my-5 pb-4 heading-three" [ngClass]="{'text-white' : planIdx == 1}">{{plan.title}}</h4>
                            <h2 class="mb-5 heading-two" [ngClass]="{'text-white' : planIdx == 1}">${{plan.price}} <span class="paragraph-global-text">/project</span></h2>  
                            <p class="paragraph-global-text">{{plan.description}}</p>
                            <!-- buttons section  -->
                            <a class="pricing-btn save-btn w-fit d-block mb-5 mt-3 w-100" [href]="signUrl+'sign-in'" target="_blank" [ngClass]="{'cfa' : planIdx == 1}">{{plan.button}}</a>
                        </div>

                        <div class="card-bottom-part">
                            <div>
                                <ul class="fa-ul">                               
                                    <li *ngFor="let feature of plan.features"><span class="fa-li"><i class="fas fa-circle-check"></i></span> {{feature}}</li>                                
                                </ul>              
                            </div>       
                        </div>                              
                    </div>
                </div>
                <div class="pricing-card-css-margin hide-on-mobile" *ngIf="planIdx == 1"><span></span></div>
            </div>
        </div>
    </div>
</div>

<div class="sec-padding">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{"realEstate.whyChoose.title" | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-800 mb-0">{{'realEstate.whyChoose.description' | translate}}</p>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                     <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big icon-primary-color"><path d="M21.801 10A10 10 0 1 1 17 3.335"/><path d="m9 11 3 3L22 4"/></svg>
                     </div>
                     <h4 class="heading-three pt-1">{{'realEstate.whyChoose.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'realEstate.whyChoose.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-4 icon-primary-color"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'realEstate.whyChoose.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'realEstate.whyChoose.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign icon-primary-color"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                    </div>
                     <h4 class="heading-three pt-1">{{'realEstate.whyChoose.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'realEstate.whyChoose.section3.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                     <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-headset icon-primary-color"><path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"/><path d="M21 16v2a4 4 0 0 1-4 4h-5"/></svg>
                     </div>
                     <h4 class="heading-three pt-1">{{'realEstate.whyChoose.section4.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'realEstate.whyChoose.section4.description' | translate}}</p>
                </div>
             </div>
        </div>
    </div>
</div>


<div class="sec-padding sec-teritiary-background">
    <div class="container">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto"> {{"realEstate.clientsSay.title" | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph">{{'realEstate.clientsSay.description' | translate}}</p>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="d-flex align-items-center mb-3">
                        <div>
                            <p-avatar image="../../../assets/images/senor-proffesionals/user-2.png" class="mr-3" shape="circle"></p-avatar>
                        </div>
                        <div>
                            <h6 class="card-title mb-1">{{'realEstate.clientsSay.section1.name' | translate}}</h6>
                            <span class="sub-heading-color">{{'realEstate.clientsSay.section1.title' | translate}}</span>
                        </div>
                     </div>
                     <p class="paragraph-global-text sub-head-paragraph mb-0">{{'realEstate.clientsSay.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="d-flex align-items-center mb-3">
                        <div>
                            <p-avatar image="../../../assets/images/senor-proffesionals/user-3.png" class="mr-3" shape="circle"></p-avatar>
                        </div>
                        <div>
                            <h6 class="card-title mb-1">{{'realEstate.clientsSay.section2.name' | translate}}</h6>
                            <span class="sub-heading-color">{{'realEstate.clientsSay.section2.title' | translate}}</span>
                        </div>
                     </div>
                     <p class="paragraph-global-text sub-head-paragraph mb-0">{{'realEstate.clientsSay.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-lg-4 col-md-6 col-sm-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="d-flex align-items-center mb-3">
                        <div>
                            <p-avatar image="../../../assets/images/senor-proffesionals/user-1.png" class="mr-3" shape="circle"></p-avatar>
                        </div>
                        <div>
                            <h6 class="card-title mb-1">{{'realEstate.clientsSay.section3.name' | translate}}</h6>
                            <span class="sub-heading-color">{{'realEstate.clientsSay.section3.title' | translate}}</span>
                        </div>
                     </div>
                     <p class="paragraph-global-text sub-head-paragraph mb-0">{{'realEstate.clientsSay.section3.description' | translate}}</p>
                </div>
             </div>
        </div>
    </div>
</div>

  <!-- cfa  -->
  <div class="sec-padding cfa-sec position-relative">    
      <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">            
            <h2 class="heading-one text-white mx-auto">{{'realEstate.cfa.title' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph mw-900 text-white">{{'realEstate.cfa.description' | translate}}</p>
  
            <div>
                <a [routerLink]="['/en/book-demo']" target="_blank">
                    <button class="save-btn cfa mx-auto fw-500 mt-4">
                      {{'realEstate.cfa.btnText' | translate}}
                    </button>
                </a>
            </div>
        </div>
    </div>
  </div>
